import { type VariantProps, cva } from 'class-variance-authority'

export const statusVariants = cva(
  'inline-flex items-center justify-center text-xs shrink-0 [&>svg]:pointer-events-none focus-visible:ring-primary/50 focus-visible:ring-[3px] transition-[color,box-shadow] overflow-hidden',
  {
    variants: {
      variant: {
        comingSoon: 'bg-orange text-white min-w-[60px] whitespace-nowrap',
        secondary: 'bg-primary-light text-primary text-center',
        gray: 'bg-gray-ultra-light text-center',
        soldOut: 'bg-red text-white whitespace-nowrap',
        limitedEdition: 'text-black font-sans-bold whitespace-nowrap',
      },
      position: {
        rotated:
          'absolute transform rotate-[-90deg] translate-x-[-50%] translate-y-[-15%] top-[50%] left-2 w-full min-h-0',
      },
      padding: {
        base: 'px-5 py-1',
        small: 'px-2 py-0.5',
      },
      width: {
        full: 'w-full',
        fit: ' w-fit',
      },
    },
    defaultVariants: {
      variant: 'comingSoon',
      position: null,
      padding: 'base',
      width: 'fit',
    },
  }
)

export type StatusVariants = VariantProps<typeof statusVariants>
